import { TwSolicitudJerarquiaViewModel } from '../datosbasicos/datosbasicos.types';

export class SolicitudSeguimientoViewModel {
    public Id: number;
    public IdEstadoSolicitud: number;
    public IdEstadoSolicitudDescripcion: string;
    public IdTipoSolicitud: number;
    public IdTipoSolicitudDescripcion: string;
    public IdEstadoChedPp: number | null;
    public IdEstadoChedPpDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public EsPredua: boolean;
    public EsPrevia: boolean;
    public EsReImportacion: boolean;
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
    public TComentarioInspectorCollection: TComentarioInspectorViewModel[];
}

export class TComentarioInspectorViewModel {
    public IdSolicitud: number;
    public IdEstadoSolicitud: number;
    public IdEstadoSolicitudDescripcion: string;
    public IdTipoSolicitud: number;
    public IdTipoSolicitudDescripcion: string;
    public IdEstadoChedPp: number | null;
    public IdEstadoChedPpDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public EsPredua: boolean;
    public EsPrevia: boolean;
    public EsReImportacion: boolean;
    public Id: number;
    public IdInspector: number;
    public Inspector = '';
    public Fecha: Date;
    public Observaciones = '';
    public IdSeccion: number;
    public IdMotivo: number;
    public IdSeccionDescripcion: string;
    public IdMotivoDescripcion: string;
    public VisibleSolicitante: boolean;
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
}

//export class FilterSearchingSeguimientoViewModel extends FilterSearchingBaseViewModel {

//    public IdSolicitud: number;

//}
